import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { request } from 'http';
import { resolve } from 'url';
import { environment } from '../../environments/environment';

@Injectable()
export class StripeService {

  constructor(private http: Http) { }

  async createCustomer (userData, userId) {

    let requestBody = {
      email: userData.email,
      userId: userId
    }
    console.log('requestBody:', requestBody);

    try {
      let res = await this.http.post(environment.apiUrl + "create-customer", requestBody).map((res) => res.json()).toPromise()

      console.log("createCust res:", res)
      
      return res
      
    } catch (error) {
      console.log('err creating customer:', error)

      return error
    }

  }

  async getBillingUrl (stripeId) {

    let requestBody = {
      returnUrl: window.location.href,
      custId: stripeId
    }

    let res;

    try {
      res = await this.http.post(environment.apiUrl + "stripe-portal-session", requestBody).map((res) => res.json()).toPromise();

      console.log("session created:", res)

    } catch (error) {
      console.log('error creating portal session:', error)

      res.errorMessage = error
    }

    return res

  }

  async createSubscription(userId, customerId, paymentMethodId) {

    let requestBody = {
      userId: userId,
      customerId: customerId,
      paymentMethodId: paymentMethodId,
      priceId: environment.subscriptionPriceID,
    }

    console.log("creating subscription with:", requestBody)

    let res;

    try {
      res = await this.http.post(environment.apiUrl + "create-subscription", requestBody).map((res) => res.json()).toPromise();

    } catch (error) {
      console.log('error creating subscription:', error)

      if(error.status && error.status !== 200){
        // there was a http error
        res = {"errorMessage": "Somethign went wrong... :("}
      } else {
        res = {"errorMessage": error}
      }

    }

    return res

  }

}



// WEBPACK FOOTER //
// ./src/app/services/stripe.service.ts